import { COLOR, mq, FONT_SIZE, FONT_WEIGHT } from "@dmm-com/rocket-web-ui-library";
import styled from "@emotion/styled";
import { AnimationContainer } from "~/components/blocks/layout/global-navi/mobile/right/search-form/style";
import { GLOBAL_NAVI_HEIGHT } from "~/styles/layout";
import { Z_INDEX } from "~/styles/z-index";

export const DivContainer = styled(AnimationContainer)`
  position: fixed;
  height: 100vh;
  width: 100%;
  height: calc((var(--vh, 1vh) * 100 - ${GLOBAL_NAVI_HEIGHT.PC}px));
  top: ${GLOBAL_NAVI_HEIGHT.PC}px;
  left: 0;
  padding: calc(var(--sat) + 16px) calc(var(--sar) + 16px) calc(var(--sab) + 16px) calc(var(--sal) + 16px);
  z-index: ${Z_INDEX.RANKING_LIST};
  background-color: ${COLOR.GRAY100.code};
  overflow-y: auto;
  ${mq.sp} {
    top: ${GLOBAL_NAVI_HEIGHT.SP}px;
    height: calc((var(--vh, 1vh) * 100) - ${GLOBAL_NAVI_HEIGHT.SP}px);
  }
`;

export const DivHeading = styled.div`
  font-size: ${FONT_SIZE.M}px;
  font-weight: ${FONT_WEIGHT.BOLD};
  height: 40px;
  line-height: 40px;
`;

export const ULContainer = styled.ul``;
